// ─── Rayons (allées de supermarché) — données pures ────────────────
// Sert à regrouper le référentiel d'ingrédients (cf. ingredientsBase/
// ingredientsPerso) par rayon. Le CRUD Firestore du catalogue vit désormais
// dans ces deux fichiers (base globale + calque personnel) — ce module ne
// porte plus que la donnée « rayons ».
export const RAYONS = [
  { id: 'fruits_legumes', label: 'Fruits & Légumes', emoji: '🥬' },
  { id: 'cremerie', label: 'Crèmerie & Œufs', emoji: '🧀' },
  { id: 'boucherie', label: 'Boucherie & Volaille', emoji: '🥩' },
  { id: 'poissonnerie', label: 'Poissonnerie', emoji: '🐟' },
  { id: 'boulangerie', label: 'Pain & Pâtisserie', emoji: '🥖' },
  { id: 'epicerie_salee', label: 'Épicerie salée', emoji: '🥫' },
  { id: 'epicerie_sucree', label: 'Épicerie sucrée', emoji: '🍫' },
  { id: 'petit_dej', label: 'Petit-déjeuner', emoji: '☕' },
  { id: 'boissons', label: 'Boissons', emoji: '🥤' },
  { id: 'surgeles', label: 'Surgelés', emoji: '🧊' },
  { id: 'entretien', label: 'Entretien & Maison', emoji: '🧽' },
  { id: 'autre', label: 'Autre', emoji: '📦' },
];
const RAYON_INCONNU = { id: 'autre', label: 'Autre', emoji: '📦' };
export function rayonDe(id, rayons) {
  const src = (rayons && rayons.length) ? rayons : RAYONS;
  return src.find(r => r.id === id) || src.find(r => r.id === 'autre') || RAYON_INCONNU;
}
export function ordreRayon(id, rayons) {
  const src = (rayons && rayons.length) ? rayons : RAYONS;
  const i = src.findIndex(r => r.id === id);
  return i < 0 ? src.length : i;
}
